var moneyFormat = window.price.money_format || '${{amount}}';

function formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || moneyFormat;

  function formatWithDelimiters(number) {
    var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    var thousands = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ',';
    var decimal = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.');
    var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

function setGalleryScroll(gallery, slider) {
  if (!gallery && !slider) return;

  const slides = slider.querySelectorAll("img");
  const dots = gallery.querySelectorAll(".set-selector__slider-dot");
  const sliderRect = slider.getBoundingClientRect();
  let minDiff = Infinity;
  let activeIndex = 0;

  slides.forEach((slide, i) => {
    const diff = Math.abs(slide.getBoundingClientRect().left - sliderRect.left);
    if (diff < minDiff) {
      minDiff = diff;
      activeIndex = i;
    }
  });

  dots.forEach(dot => dot.classList.remove("active"));

  if (dots[activeIndex]) {
    dots[activeIndex].classList.add("active");
  }
}

document.addEventListener('DOMContentLoaded', () => {
  class SetSelector {
    constructor() {
      this.container = document.getElementById("setSelector");
      if (!this.container) return;
      this.wrapper = this.container.closest(".product-info");
      if (!this.wrapper) return;

      this.modalTriggers = this.wrapper.querySelectorAll('[data-modal-id]');
      this.modals = this.wrapper.querySelectorAll('.set-selector__modal');
      this.closeButtons = this.wrapper.querySelectorAll('[data-modal-close]');
      this.productPickers = this.wrapper.querySelectorAll('.set-selector__item');
      this.modalProducts = this.wrapper.querySelectorAll('.set-selector__modal-items > button:not([data-size-modal]):not([data-modal-close-size])');
      this.addToCartButton = this.wrapper.querySelector('[data-add-to-cart]');
      this.chooseDesign = this.wrapper.querySelector('[data-choose-design]');
      this.designCountText = this.wrapper.querySelector('[data-design-count]');
      this.addToCartText = this.wrapper.querySelector('[data-add-to-cart-text]');
      this.totalPriceEl = this.wrapper.querySelector('[data-total-price]');
      this.savePriceEl = this.wrapper.querySelector('[data-save-price]');
      this.backdropEl = this.wrapper.querySelector("[data-modal-backdrop]");
      this.setButtons = this.wrapper.querySelectorAll(".set-selector__set[data-sets-id]");
      this.setWrappers = this.wrapper.querySelectorAll('.set-selector__item-wrap');
      this.setMessage = this.wrapper.querySelectorAll('.set-selector__set-message');
      this.dropdownButton = this.wrapper.querySelector('[data-dropdown-button]');
      this.dropdownContainer = this.wrapper.querySelector('.set-selector__dropdown-container');
      this.setDropdown = this.wrapper.querySelectorAll('.set-selector__dropdown-content[data-dropdown-id]');
      this.setCount = this.wrapper.querySelector("[data-slot-count]");
      this.setHint = this.wrapper.querySelector("[data-hint]");
      this.setHintText = this.wrapper.querySelectorAll(".set-selector__hint-text[data-hint-text-id]")
      // this.setHintHeadings = this.wrapper.querySelectorAll(".set-selector__hint-heading[data-hint-id]");
      this.openModals = false;
      this.selectedProducts = [null, null, null, null, null, null, null, null, null];
      this.activeSlot = null;
      this.totalPrice = [0, 0, 0, 0, 0, 0, 0, 0, 0];
      this.savePrice = 0;
      this.activeSetId = '1'
      this.slot4Quantity = { '1': 4, '2': 4, '3': 6 };

      this.bindEvents();
      this.handleEditParameters();
      this.markPreFilledProducts();
      this.showSetItems('1')
    }

    getVisibleSlotIndexes() {
      const slotToShowMap = {
        '1': [0, 1, 4],
        '2': [0, 1, 2, 4, 5, 6],
        '3': [0, 1, 2, 3, 4, 5, 6, 7, 8]
      };
      return slotToShowMap[this.activeSetId] || [];
    }

    markPreFilledProducts() {
      this.productPickers.forEach((slot, index) => {
        if (index >= 4 && index <= 8) {
          slot.removeAttribute('data-pre-filled');
        }
      });

      const freeProductIds = [
        window.freeProduct1Id,
        window.freeProduct2Id,
        window.freeProduct3Id,
        window.freeProduct4Id,
        window.freeProduct5Id
      ];
      
      const freeProductVariantIds = [
        window.freeProduct1VariantId,
        window.freeProduct2VariantId,
        window.freeProduct3VariantId,
        window.freeProduct4VariantId,
        window.freeProduct5VariantId
      ];

      for (let i = 4; i <= 8; i++) {
        const slot = this.productPickers[i];
        if (!slot) continue;
        
        const titleElement = slot.querySelector('[data-product-title]');
        const currentTitle = titleElement?.innerText;
        const productIndex = i - 4;
        
        if (currentTitle && 
            currentTitle !== window.locales.cat && 
            currentTitle === this.getFreeProductTitle(i)) {
          
          slot.classList.remove('empty');
          slot.classList.add('show-remove', 'set-selector__item--free');
          slot.setAttribute('data-pre-filled', 'true');
          
          const imgSrc = slot.querySelector('[data-item-image]')?.getAttribute('src') || '';
          const price = slot.querySelector('[data-item-price]')?.innerText || '';
          const priceValue = this.extractPriceValue(price);
          const selectedOptions = slot.querySelector('[data-options]')?.innerText || '';
          
          this.selectedProducts[i] = {
            title: currentTitle,
            imgSrc: imgSrc,
            variantId: freeProductVariantIds[productIndex] || null,
            productId: freeProductIds[productIndex] || null,
            price: price,
            priceValue: priceValue,
            selectedOptions: selectedOptions,
            isFree: true,
            isPreFilled: true
          };

          if (freeProductVariantIds[productIndex]) {
            slot.setAttribute('data-variant-id', freeProductVariantIds[productIndex]);
          }
          if (freeProductIds[productIndex]) {
            slot.setAttribute('data-product-id', freeProductIds[productIndex]);
          }
        }
      }
      this.updateSlotQuantityDisplay();
    }

    extractPriceValue(priceString) {
      if (!priceString) return 0;
      const matches = priceString.match(/\d+/g);
      if (matches) {
        return parseInt(matches.join(''));
      }
      return 0;
    }

    updateSlotQuantityDisplay() {
      const slot = this.productPickers[4];
      if (!slot) return;

      const quantity = this.slot4Quantity[this.activeSetId] || 4;
      const priceElement = slot.querySelector("[data-item-price");
      const originalPrice = this.getFreeProductPriceValue(4);

      if (priceElement && originalPrice) {
        const multipliedPrice = originalPrice * quantity;
        priceElement.innerText = formatMoney(multipliedPrice, moneyFormat);
        if (this.selectedProducts[4]) {
          this.selectedProducts[4].priceValue = multipliedPrice;
          this.selectedProducts[4].price = formatMoney(multipliedPrice, moneyFormat);
          this.selectedProducts[4].quantity = quantity;
        }
      }

      const titleElement  = slot.querySelector("[data-product-title]");
      if (titleElement ) {
        const productTitle = this.getFreeProductTitle(4);
        titleElement.innerText = `${quantity} × ${productTitle}`;
      }
    }

    getFreeProductPriceValue(index) {
      const priceValueMap = {
        4: window.freeProduct1PriceValue,
        5: window.freeProduct2PriceValue,
        6: window.freeProduct3PriceValue,
        7: window.freeProduct4PriceValue,
        8: window.freeProduct5PriceValue
      };
      return priceValueMap[index] || 0;
    }

    showSetItems(setId) {
      this.setWrappers.forEach(slot => {
        slot.classList.add('hidden');
      });

      this.setMessage.forEach(mes => {
        mes.classList.add('hidden');
      });

      this.setDropdown.forEach(dd => {
        dd.classList.add('hidden');
      })

      this.setHintText.forEach(text => {
        text.classList.add('hidden');
      })

      // this.resetSelectedProducts();

      const slotToShowMap = {
        '1': [0, 1, 4],     
        '2': [0, 1, 2, 4, 5, 6], 
        '3': [0, 1, 2, 3, 4, 5, 6, 7, 8] 
      };

      const messageToShowList = { '1': [0], '2': [1], '3': [2] };
      const ddToShowList = { '1': [0], '2': [1], '3': [2]};
      const hintToShowList = { '1': [0], '2': [1], "3": [2] };

      const slotToShow = slotToShowMap[setId] || [];
      const messageToShow = messageToShowList[setId] || [];
      const ddToShow = ddToShowList[setId] || [];
      const hintToShow = hintToShowList[setId] || [];

      slotToShow.forEach(slotIndex => {
        if (this.setWrappers[slotIndex]) {
          this.setWrappers[slotIndex].classList.remove('hidden');
        }
      });

      messageToShow.forEach(messageIndex => {
        if (this.setMessage[messageIndex]) {
          this.setMessage[messageIndex].classList.remove('hidden');
        }
      });

      ddToShow.forEach(ddIndex => {
        if (this.setDropdown[ddIndex]) {
          this.setDropdown[ddIndex].classList.remove('hidden');
        }
      })

      hintToShow.forEach(hintIndex => {
        if (this.setHintText[hintIndex]) {
          this.setHintText[hintIndex].classList.remove('hidden');
        }
      })

      this.setButtons.forEach(button => {
        if (button.dataset.setsId === setId) { 
          button.classList.add('active');
        } else {
          button.classList.remove('active');
        }
      });

      this.activeSetId = setId;
      this.updateSlotQuantityDisplay();
      this.updateSlotCounter()
      this.updateUI();
    }

    // resetSelectedProducts() {
    //   this.selectedProducts = [null, null, null, null, null, null, null, null, null];
    //   this.totalPrice = [0, 0, 0, 0, 0, 0, 0, 0, 0];
      
    //   this.productPickers.forEach((slot, index) => {
    //     const isFreeItem = index >= 4 && index <= 8;
        
    //     const emptyTitleText = isFreeItem ? this.getFreeProductTitle(index) : `${window.locales.design} ${index + 1}`;
    //     const imageSrc = isFreeItem ? this.getFreeProductImage(index) : "";
    //     const defaultPrice = isFreeItem ? this.getFreeProductPrice(index) : formatMoney(3295, moneyFormat);
        
    //     const titleElement = slot.querySelector('[data-product-title]');
    //     const imageElement = slot.querySelector('[data-item-image]');
    //     const priceElement = slot.querySelector('[data-item-price]');
    //     const optionsElement = slot.querySelector('[data-options]');
        
    //     if (titleElement) titleElement.innerText = emptyTitleText;
    //     if (imageElement) imageElement.setAttribute('src', imageSrc);
    //     if (priceElement) priceElement.innerText = defaultPrice;
    //     if (optionsElement) optionsElement.innerText = "";
        
    //     if (isFreeItem) {
    //       const productIndex = index - 4;
    //       const variantId = window[`freeProduct${productIndex + 1}VariantId`];
    //       const productId = window[`freeProduct${productIndex + 1}Id`];
          
    //       if (variantId) slot.setAttribute('data-variant-id', variantId);
    //       if (productId) slot.setAttribute('data-product-id', productId);
    //     } else {
    //       slot.removeAttribute('data-variant-id');
    //       slot.removeAttribute('data-product-id');
    //     }
        
    //     slot.classList.remove("show-remove");
    //     slot.classList.add("empty");
    //     slot.removeAttribute('data-pre-filled');
    //   });
    //   this.markPreFilledProducts();
    //   this.updateSlotCounter();
    // }

    getFreeProductTitle(index) {
      const productMap = {
        4: window.freeProductCustomTitle || window.freeProduct1Title,
        5: window.freeProduct2Title || 'Cat 2',
        6: window.freeProduct3Title || 'Cat 3',
        7: window.freeProduct4Title || 'Cat 4',
        8: window.freeProduct5Title || 'Cat 5'
      };
      return productMap[index] || window.locales.cat;
    }

    getFreeProductImage(index) {
      const imageMap = {
        4: window.freeProduct1Image || window.placeHolderImage,
        5: window.freeProduct2Image || window.placeHolderImage,
        6: window.freeProduct3Image || window.placeHolderImage,
        7: window.freeProduct4Image || window.placeHolderImage,
        8: window.freeProduct5Image || window.placeHolderImage
      };
      return imageMap[index] || window.placeHolderImage;
    }

    getFreeProductPrice(index) {
      const priceValueMap = {
        4: window.freeProduct1PriceValue,
        5: window.freeProduct2PriceValue,
        6: window.freeProduct3PriceValue,
        7: window.freeProduct4PriceValue,
        8: window.freeProduct5PriceValue
      };
      
      const priceValue = priceValueMap[index];
      if (priceValue) {
        return formatMoney(priceValue, moneyFormat);
      }
      
      const priceMap = {
        4: window.freeProduct1Price || formatMoney(3295, moneyFormat),
        5: window.freeProduct2Price || formatMoney(3295, moneyFormat),
        6: window.freeProduct3Price || formatMoney(3295, moneyFormat),
        7: window.freeProduct4Price || formatMoney(3295, moneyFormat),
        8: window.freeProduct5Price || formatMoney(3295, moneyFormat)
      };
      return priceMap[index] || formatMoney(3295, moneyFormat);
    }

    updateSlotCounter() {
      const visibleSlotIndexes = this.getVisibleSlotIndexes();
      const visiblePaidSlotIndexes = visibleSlotIndexes.filter(index => index <= 3);
      const totalPaidSlots = visiblePaidSlotIndexes.length;
      
      const filledPaidSlots = visiblePaidSlotIndexes.filter(index => 
        this.selectedProducts[index] !== null
      ).length;
      
      if (this.setCount) {
        this.setCount.innerText = `${filledPaidSlots} ${window.locales?.of || 'von'} ${totalPaidSlots} ${window.locales?.selected || 'ausgewählt'}`;
        if (filledPaidSlots === totalPaidSlots) {
          this.setCount.classList.add('filled');
        } else {
          this.setCount.classList.remove('filled');
        }
      }

      this.updateHint(filledPaidSlots, totalPaidSlots);
    }

    updateHint(filledPaidSlots, totalPaidSlots) {
      if (!this.setHint) return;
      const hintHeadings = this.setHint.querySelectorAll('.set-selector__hint-heading');
      hintHeadings.forEach(heading => heading.classList.add('hidden'));
      
      if (filledPaidSlots === 0) {
        this.setHint.classList.remove('show');
      } else {
        this.setHint.classList.add('show');
        
        if (filledPaidSlots < totalPaidSlots) {
          const hint0 = this.setHint.querySelector('[data-hint-id="0"]');
          if (hint0) hint0.classList.remove('hidden');
        } else if (filledPaidSlots === totalPaidSlots) {
          const hint1 = this.setHint.querySelector('[data-hint-id="1"]');
          if (hint1) hint1.classList.remove('hidden');
        }
      }
    }

    async loadAllProducts(modalId) {
      let page = 1;
      const modal = document.getElementById(modalId);

      if (modal && !modal.classList.contains("loaded")) {
        const collectionHandle = modal.getAttribute("data-collection-handle");
        const collectionType = modalId.includes("free") ? "free" : "paid";
        const container = modal.querySelector("[data-load-more-target-container]");
        const mainProductHandle = modal.getAttribute("data-main-product-handle");
        const filterContainer = modal.querySelector("[data-filters]");

        try {
          container.innerHTML = window.locales.loading;
          const response = await fetch(`/collections/${collectionHandle}/products.json?page=${page}&limit=250`);
          const data = await response.json();
          const products = data?.products?.filter(p => 
            p.handle !== mainProductHandle && 
            !window.excludeHandles.includes(p.handle) &&
            !p.tags?.some(tag => window.excludedTags.includes(tag))
          );
          
          container.innerHTML = "";

          if (products && products.length > 0) {
            products.forEach(product => {
              const productElement = this.createProductElement(product, collectionType);
              container.insertAdjacentHTML('beforeend', productElement);
            });

            this.updateFilters(data.products, filterContainer);

            if (data.products.length === 50) {
              await this.loadAllProducts(collectionHandle, page + 1);
            }
          }

          modal.classList.add("loaded");
        } catch (error) {
          console.error('Error loading products:', error);
        }
      }
    }

    updateFilters(products, filterContainer) {
      const filters = new Set([...products.map(product => product.product_type ? product.product_type : null).filter(i => i !== null)]) 

      filterContainer.innerHTML = "";
      
      filters.forEach(filter => {
        const filterButton = this.createFilterButton(filter);
        filterContainer.insertAdjacentHTML("beforeend", filterButton);
      })
    }

    isCombinationAvailable(activeOptionsArray, variants, optionsDefs) {
      const names = optionsDefs.map(o => typeof o === 'string' ? o : o.name);

      const activeByName = {};
      names.forEach((name, idx) => { activeByName[name] = activeOptionsArray[idx] ?? null; });

      return variants.some(variant => {
        if (!variant.available) return false;

        const variantOptions = [variant.option1, variant.option2, variant.option3];

        return variantOptions.every((opt, idx) => {
          if (opt == null) return true;
          const name = names[idx];
          const selected = activeByName[name];
          return selected == null || selected === opt;
        });
      });
    }

    updateButtons(modal) {
      const script = modal.querySelector("script[data-product-variant-ids]");
      const scriptOptions = modal.querySelector("script[data-product-options-script]");
      const parsedOptions = JSON.parse(scriptOptions.innerText);
      const parsedVariants = JSON.parse(script.innerText);
      const activeOptions = parsedOptions.map(() => null);
      const activeButtons = modal.querySelectorAll("button[data-value-button].active");
    
      activeButtons.forEach((button, idx) => {
        const parent = button.closest("[data-option-container]");
        const label = parent.querySelector("[data-selected-value]").closest(".set-selector__option-head").querySelector("span");
        const name = label.innerText.trim().replace(":", "");
        const optIndex = parsedOptions.findIndex(o => o.name === name);
        if (optIndex >= 0) activeOptions[optIndex] = button.value;
      });
    
      parsedOptions.forEach((optDef, optIndex) => {
        const container = modal.querySelectorAll("[data-option-container]")[optIndex];
        const buttons = container.querySelectorAll("[data-value-button]");
    
        buttons.forEach(btn => {
          const testSelection = [...activeOptions];
          testSelection[optIndex] = btn.value;
          btn.disabled = !this.isCombinationAvailable(testSelection, parsedVariants, parsedOptions);
        });
      });
    }

    bindEvents() {
      const galleryScrollHandlers = new WeakMap();

      this.setButtons.forEach(btn => {
        btn.addEventListener('click', () => {
          const setId = btn.dataset.setsId;
          if (setId) {
            this.showSetItems(setId);
            this.updateSlotCounter();
          }
        })
      })

      if (this.dropdownButton && this.dropdownContainer) {
        this.dropdownButton.addEventListener('click', (e) => {
          e.stopPropagation();
          this.dropdownContainer.classList.toggle('show');
          this.dropdownButton.classList.toggle('active');
        })
      }

      this.modalTriggers.forEach((btn, index) => {
        btn.addEventListener('click', (e) => {
          const isFilled = btn.classList.contains('show-remove');
          const isPreFilledFree = index >= 4 && index <= 8 && 
                                btn.querySelector('[data-product-title]')?.innerText !== window.locales.cat;
          
          if (isFilled || isPreFilledFree) {
            e.preventDefault();
            e.stopPropagation();
            return;
          }

          this.activeSlot = index;
          const modalId = btn.dataset.modalId;
          this.openModal(modalId);
          this.loadAllProducts(modalId)
        });
      });

      this.closeButtons.forEach((btn) => {
        btn.addEventListener('click', () => this.closeModals());
      });

      this.addToCartButton?.addEventListener('click', () => {
        const visibleSlotIndexes = this.getVisibleSlotIndexes();
        const hasEmptyVisibleSlot = visibleSlotIndexes.some(index => {
          const slot = this.productPickers[index];
          return slot && !slot.classList.contains("show-remove");
        })

        if (hasEmptyVisibleSlot) {
          const firstEmptyIndex = visibleSlotIndexes.find(index => {
            const slot = this.productPickers[index];
            return slot && !slot.classList.contains("show-remove");
          })

          if (firstEmptyIndex !== undefined) {
            const modalButton = this.productPickers[firstEmptyIndex];
            if (modalButton && modalButton.hasAttribute('data-modal-id')) {
              modalButton.click();
            }
          }
        } else {
          this.addToCart();
        }

        // const modalButton = this.wrapper.querySelector(`button[data-modal-id]:not(.show-remove)`);
        // if (modalButton) {
        //   modalButton.click();
        // } else {
        //   this.addToCart();
        // }
      });

      if (this.backdropEl) this.backdropEl.addEventListener("click", () => this.closeModals())

      document.addEventListener("click", (e) => {
        if (e.target.closest("button[data-item-button]")) {
          const productBtn = e.target.closest("button[data-item-button]");
          
          const isPreFilledFree = productBtn.closest('.set-selector__item-wrap') && 
                                  productBtn.closest('.set-selector__item-wrap').querySelector('.set-selector__item--free') &&
                                  productBtn.closest('.set-selector__item-wrap').querySelector('[data-product-title]')?.innerText !== window.locales.cat;
          
          if (isPreFilledFree) {
            e.preventDefault();
            e.stopPropagation();
            return;
          }

          const title = productBtn.querySelector('[data-product-title]').innerText.trim();
          const imgSrc = productBtn.querySelector('[data-item-image]').getAttribute('src');
          const variantId = productBtn.dataset.variantId;
          const productId = productBtn.dataset.productId;
          const price = productBtn.dataset.productPrice;
          const priceValue = productBtn.dataset.productPriceValue;
          const selectedOptions = productBtn.dataset.selectedOptions;

          if (!productBtn.hasAttribute("data-free-product")) {
            this.totalPrice[this.activeSlot] = priceValue;
          } 

          if (!variantId) {
            console.error('No variant id on selected product');
            return;
          }

          this.selectedProducts[this.activeSlot] = {
            title,
            imgSrc,
            variantId,
            productId,
            price,
            priceValue: +priceValue,
            selectedOptions,
            isFree: productBtn.hasAttribute("data-free-product") 
          };

          const slot = this.productPickers[this.activeSlot];

          slot.querySelector('[data-product-title]').innerText = title;
          slot.querySelector('[data-item-image]').setAttribute('src', imgSrc);
          slot.querySelector('[data-item-price]').innerText = price;
          slot.querySelector('[data-options]').innerText = selectedOptions;
          
          slot.setAttribute('data-variant-id', variantId);
          if (productId) {
            slot.setAttribute('data-product-id', productId);
          }

          if (selectedOptions.includes("Default Title")) {
            slot.querySelector('[data-options]').innerText = "";
          }

          slot.classList.remove("empty");
          slot.classList.add("show-remove");

          this.updateUI();
          this.closeModals();
          this.updateSlotCounter()
        }

        if (e.target.closest("[data-remove-product]")) {
          const target = e.target.closest("[data-remove-product]");
          const activeSlotId = target.getAttribute("data-slot-id");
          const slot = this.productPickers[+activeSlotId];
          const isFreeItem = +activeSlotId >= 4 && +activeSlotId <= 8;
          
          if (isFreeItem && slot.hasAttribute('data-pre-filled')) {
            e.preventDefault();
            e.stopPropagation();
            return;
          }

          const emptyTitleText = isFreeItem ? this.getFreeProductTitle(+activeSlotId) : `${window.locales.design} ${+activeSlotId + 1}`;
          const imageSrc = isFreeItem ? this.getFreeProductImage(+activeSlotId) : "";

          slot.querySelector('[data-product-title]').innerText = emptyTitleText;
          slot.querySelector('[data-item-image]').setAttribute('src', imageSrc);
          slot.querySelector('[data-item-price]').innerText = isFreeItem ? this.getFreeProductPrice(+activeSlotId) : formatMoney(3295, moneyFormat);
          slot.querySelector('[data-options]').innerText = "";
          slot.classList.remove("show-remove");

          if (isFreeItem) {
            const productIndex = +activeSlotId - 4;
            const variantId = window[`freeProduct${productIndex + 1}VariantId`];
            const productId = window[`freeProduct${productIndex + 1}Id`];
            
            if (variantId) slot.setAttribute('data-variant-id', variantId);
            if (productId) slot.setAttribute('data-product-id', productId);
          }

          if (!isFreeItem) {
            slot.classList.add("empty");
            this.totalPrice[+activeSlotId] = 0;
          } else {
            slot.classList.add("empty");
          }

          this.selectedProducts[+activeSlotId] = null;
          this.updateUI();
          this.updateSlotCounter()
        }

        if (e.target.closest("[data-modal-close-size]")) {
          const target = e.target.closest("[data-modal-close-size]");
          const modalId = target.getAttribute("data-modal-close-size");
          const modal = target.closest(`[id='${modalId}']`);

          if (modal) modal.classList.remove("show");

          const slider = modal.querySelector(".set-selector__modal-slider");

          if (slider && galleryScrollHandlers.has(slider)) {
            const handler = galleryScrollHandlers.get(slider);

            slider.removeEventListener("scroll", handler);

            galleryScrollHandlers.delete(slider);
          }
        }

        if (e.target.closest("button[data-size-modal]")) {
          const target = e.target.closest("button[data-size-modal]");
          const modalId = target.getAttribute("data-size-modal");
          const modal = this.wrapper.querySelector(`[id='${modalId}']`);
          if (modal) {
            if (!modal.classList.contains("show")) modal.classList.add("show");

            const gallery = modal.querySelector(".set-selector__modal-gallery");
            const slider = gallery.querySelector(".set-selector__modal-slider");
            const handler = () => setGalleryScroll(gallery, slider);
            slider.addEventListener("scroll", handler);
            galleryScrollHandlers.set(slider, handler);
          }
        }

        if (e.target.closest("[data-value-button]:not(.active)")) {
          const target = e.target.closest("[data-value-button]");
          const parent = target.closest("[data-option-container]");
          const modal = target.closest("[data-modal-options]");

          if (parent) {
            parent.querySelectorAll("[data-value-button]").forEach(i => i.classList.remove("active"));
            const selectedValueElement = parent.querySelector("[data-selected-value]");
            const sizeChartButton = selectedValueElement.querySelector('.size-chart-button');
            if (sizeChartButton) {
              let valueSpan = selectedValueElement.querySelector('.selected-option-value');
              if (!valueSpan) {
                valueSpan = document.createElement('span');
                valueSpan.className = 'selected-option-value';
                sizeChartButton.insertAdjacentElement('afterend', valueSpan);
              }
            } else {
              selectedValueElement.innerText = target.value;
            }
          }

          target.classList.add("active");
          this.updateButtons(modal);
        }

        if (e.target.closest("[data-submit-button]")) {
          const activeOptions = [];
          const target = e.target.closest("[data-submit-button]");
          const modal = target.closest("[data-modal-options]");
          const script = modal.querySelector("script[data-product-variant-ids]");
          const parsedVariants = JSON.parse(script.innerText);
          const activeButtons = modal.querySelectorAll("button[data-value-button].active");
          activeButtons.forEach(button => activeOptions.push(button.value));
          const currentVariant = this.getVariantBySelectedOptions(parsedVariants, activeOptions);
          const itemButton = modal.closest(".set-selector__item-wrapper")?.querySelector("button[data-item-button]");
          if (itemButton) {
            const prevVariantId = itemButton.getAttribute("data-variant-id");

            if (+prevVariantId !== currentVariant.id) {
              itemButton.setAttribute("data-variant-id", currentVariant.id);
              itemButton.setAttribute("data-selected-options", activeOptions.join(", "));
            }

            itemButton.click();
            modal.classList.remove("show");
          }
        }

        if (e.target.closest(".set-selector__slider-dot")) {
          const dot = e.target.closest(".set-selector__slider-dot");
          const gallery = dot.closest(".set-selector__modal-gallery");
          const dots = gallery.querySelectorAll(".set-selector__slider-dot");
          const slider = gallery.querySelector(".set-selector__modal-slider");
          const slides = slider.querySelectorAll("img");
          const index = [...dots].indexOf(dot);

          if (index >= 0) {
            slider.scrollTo({
              left: slides[index].offsetLeft,
              behavior: "smooth"
            });
          }
        }

        if (e.target.closest("[data-filter]")) {
          const target = e.target.closest("[data-filter]");
          const filterValue = target.getAttribute("data-filter");
          const buttons = target.parentNode.querySelectorAll(".active");
          const modal = target.closest("[data-modal]");
          const productsContainer = modal.querySelector("[data-load-more-target-container]")
          const items = productsContainer.querySelectorAll("[data-product-type]");

          if (target.classList.contains("active")) {
            target.classList.remove("active");
            items.forEach(item => item.parentNode.classList.remove("hidden"));
          } else {
            buttons.forEach(button => button.classList.remove("active"))
            target.classList.add("active");
            items.forEach(item => item.parentNode.classList.toggle("hidden", item.getAttribute("data-product-type") !== filterValue));
          }
        }

        if (this.dropdownContainer && !this.dropdownContainer.contains(e.target)) {
          this.dropdownContainer.classList.remove('show');
          this.dropdownButton.classList.remove('active')
        }
      });
    }

    getVariantBySelectedOptions(variants, options) {
      const filteredOptions = options.filter(opt => opt !== null && opt !== undefined && opt !== '');

      return variants.find(variant => {
        const variantOptions = [
          variant.option1,
          variant.option2,
          variant.option3
        ].filter(opt => opt !== null && opt !== undefined && opt !== '');

        if (variantOptions.length !== filteredOptions.length) {
          console.log('Options length mismatch:', variantOptions.length, 'vs', filteredOptions.length);
          return false;
        }

        const isMatch = variantOptions.every((opt, index) => opt === filteredOptions[index]);

        return isMatch;
      }) || null;
    }

    zIndexFix() {
      const productInfoEl = this.wrapper;

      if (productInfoEl) {
        if (this.openModals) {
          productInfoEl.style.zIndex = 10;
        } else {
          productInfoEl.style.zIndex = 1;
        }
      }
    }

    openModal(id) {
      this.closeModals();

      const modal = this.wrapper.querySelector(`[id='${id}']`);

      if (modal && !modal.classList.contains("show")) modal.classList.add('show');
      if (this.backdropEl && !this.backdropEl.classList.contains("show")) this.backdropEl.classList.add("show")
      if (!document.documentElement.classList.contains("lock")) document.documentElement.classList.add("lock");
      this.openModals = true;
      this.zIndexFix();
    }

    closeModals() {
      this.modals.forEach(modal => modal.classList.remove('show'));
      this.backdropEl.classList.remove("show")
      document.documentElement.classList.remove("lock");
      this.openModals = false;
      this.zIndexFix();
    }

    updateUI() {
      const visibleSlotIndexes = this.getVisibleSlotIndexes();
      const visibleSelectedProduct = visibleSlotIndexes.map(index => this.selectedProducts[index]);
      
      const firstEmptyIndex = visibleSelectedProduct.findIndex(p => {
        if (p === null) return true;
        if (p.isPreFilled) return false;
        return false;
      });
      
      const totalVisibleCount = visibleSlotIndexes.length;

      if (this.designCountText) {
        this.designCountText.innerHTML = firstEmptyIndex + 1;
      }

      const allVisibleFilled = visibleSelectedProduct.every(p => p !== null)

      if (allVisibleFilled) {
        if (this.chooseDesign && !this.chooseDesign.classList.contains("hidden")) this.chooseDesign.classList.add("hidden");
        this.addToCartText?.classList.remove("hidden");
      } else {
        this.chooseDesign?.classList.remove("hidden");
        if (this.addToCartText && !this.addToCartText.classList.contains("hidden")) this.addToCartText.classList.add("hidden");
      }

      this.updatePrice(!allVisibleFilled, firstEmptyIndex !== -1 ? totalVisibleCount : firstEmptyIndex)
    }

    updatePrice(showText, count) {
      const priceToShow = {
        finalPrice: "",
        oldPrice: "",
      };

      const mainPrice = window.mainProductPrice || 0;
      const visibleSlotIndexes = this.getVisibleSlotIndexes();
      const visiblePaidTotal = visibleSlotIndexes
        .filter(index => index <= 3)
        .reduce((sum, index) => sum + (+this.totalPrice[index] || 0), 0);
      const visibleFreeTotal = visibleSlotIndexes
        .filter(index => index >= 4 && index <= 8 && this.selectedProducts[index] !== null)
        .reduce((sum, index) => sum + (+this.selectedProducts[index]?.priceValue || 0), 0);
      
      const totalPriceResult = visiblePaidTotal + mainPrice;
      const totalOriginalPrice = totalPriceResult + visibleFreeTotal;

      priceToShow.finalPrice = formatMoney(totalPriceResult, moneyFormat);
      priceToShow.oldPrice = formatMoney(totalOriginalPrice, moneyFormat);

      this.totalPriceEl.innerHTML = totalOriginalPrice === totalPriceResult 
        ? `${priceToShow.finalPrice}` 
        : `<span class="line-through text-subdued">${priceToShow.oldPrice}</span> ${priceToShow.finalPrice}`;
      
      if (showText) {
        this.savePriceEl.innerText = "---";
      } else {
        const saveAmount = visibleFreeTotal;
        this.savePriceEl.innerText = formatMoney(saveAmount, moneyFormat);
      }

      // this.savePriceEl.innerText = showText ? "---" : formatMoney(visibleFreeTotal, moneyFormat);
    }

    setLoading(set) {
      if (!this.addToCartText.classList.contains("hidden")) this.addToCartText.classList.add("hidden");

      const pillLoader = this.wrapper.querySelector(".set-selector [data-add-to-cart] pill-loader");

      if (pillLoader) {
        pillLoader.setAttribute("aria-busy", true);
        pillLoader.classList.remove("hidden");
      }

      if (!set) {
        this.addToCartText.classList.remove("hidden");
        if (pillLoader) {
          pillLoader.removeAttribute("aria-busy")
          if (!pillLoader.classList.contains("hidden")) pillLoader.classList.add("hidden");
        }
      }
    }

    cartUpdate() {
      document.dispatchEvent(new CustomEvent("cart:refresh"));

      const drawer = document.querySelector("cart-drawer");

      if (drawer) {
        drawer.show();
      }
    }

    handleEditParameters() {
      const urlParams = new URLSearchParams(window.location.search);
      const editBundle = urlParams.get('edit_bundle');
      const bundleIds = urlParams.get('bundle_ids');
      const setId = urlParams.get('set_id');
      
      if (editBundle && bundleIds) {
        this.editingBundle = {
          mainKey: urlParams.get('main_key'),
          bundleIds: bundleIds.split(',').filter(id => id),
          bundleKey: urlParams.get('bundle_key'),
          setId: setId || '1' 
        };
        
        if (this.editingBundle.bundleIds.length > 0 && this.editingBundle.bundleKey) {
          this.setButtons.forEach(btn => {
            btn.classList.remove('active');
          });
          
          const targetSetButton = Array.from(this.setButtons).find(
            btn => btn.dataset.setsId === this.editingBundle.setId
          );
          
          if (targetSetButton) {
            console.log('Activating set:', this.editingBundle.setId);
            targetSetButton.classList.add('active');
            
            setTimeout(() => {
              this.showSetItems(this.editingBundle.setId);
              this.updateSlotCounter();
              this.preloadSelectedProducts();
            }, 100);
          } else {
            console.error('Set button not found for ID:', this.editingBundle.setId);
            this.showSetItems('1');
            this.preloadSelectedProducts();
          }
        } else {
          console.error('Invalid edit bundle parameters');
          delete this.editingBundle;
        }
      }
    }
  
    async preloadSelectedProducts() {
      try {
        const cartRes = await fetch("/cart.json");
        const cartData = await cartRes.json();
        const cartItems = cartData.items;
        const bundleIds = this.editingBundle.bundleIds;
        
        for (let i = 0; i < bundleIds.length; i++) {
          const bundleId = bundleIds[i];
          const cartItem = cartItems.find(i => i.id === +bundleId);
          if (!cartItem) continue;
          const productResponse = await fetch(`/products/${cartItem.handle}.js`);
          const productData = await productResponse.json();
          const variant = productData.variants.find(variant => variant.id === +bundleId);
          const isFree = i >= 4;
          
          this.selectedProducts[i] = {
            title: productData.title,
            imgSrc: cartItem.image|| '',
            variantId: variant.id,
            productId: productData.id,
            price: formatMoney(variant.price),
            priceValue: variant.price,
            selectedOptions: variant.options,
            isFree: isFree
          };

          if (!isFree) {
            this.totalPrice[i] = variant.price;
          }

          const slot = this.productPickers[i];

          if (slot) {
            slot.querySelector('[data-product-title]').innerText = productData.title;
            slot.querySelector('[data-item-image]').setAttribute('src', cartItem.image|| '');
            slot.querySelector('[data-item-price]').innerText = formatMoney(variant.price);
            slot.querySelector('[data-options]').innerText = variant.options;
            slot.setAttribute('data-variant-id', variant.id);
            slot.setAttribute('data-product-id', productData.id);
            
            slot.classList.remove("empty");
            slot.classList.add("show-remove");
          }
        }
        this.updateSlotCounter()
        this.updateUI();
      } catch (error) {
        console.error('Error preloading products:', error);
      }
    }

    async addToCart() {
      this.setLoading(true);

      const items = [];
      const visibleSlotIndexes = this.getVisibleSlotIndexes();
      const visibleSelectedProduct = visibleSlotIndexes
        .map(index => this.selectedProducts[index])
        .filter(p => p !== null);

      const allVisibleFilled = visibleSlotIndexes.every(index => this.selectedProducts[index] !== null);

      if (!allVisibleFilled) {
        this.setLoading(false);
        return;
      }

      if (this.editingBundle) {
        try {
          const cart = await fetch('/cart.js').then(res => res.json());
          const updates = {};
          
          cart.items.forEach(item => {
            if (item.properties?._bundle_key === this.editingBundle.bundleKey) {
              updates[item.key] = 0;
            }
          });
          
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates })
          });
          
        } catch (error) {
          console.error('Error removing old bundle:', error);
        }
      }

      const mainProductVariantId = window.mainProductVariantId;
      const bundleKey = this.editingBundle ? this.editingBundle.bundleKey : `bundle_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
      const bundleIdsStr = visibleSelectedProduct.map(p => p.variantId).join(',');
      const quantityFor4Slot = this.slot4Quantity[this.activeSetId] || 4;

      for (let i = 0; i < visibleSelectedProduct.length; i++) {
        const p = visibleSelectedProduct[i];
        
        if (!p || !p.variantId) {
          console.error('Missing variantId for product:', p);
          this.setLoading(false);
          return;
        }

        const originalSlotIndex = visibleSlotIndexes[i];
        const isFree = originalSlotIndex >= 4 && originalSlotIndex <= 8;
        let quantity = 1;
        
        if (originalSlotIndex === 4) {
          quantity = quantityFor4Slot;
        }

        const item = {
          id: Number(p.variantId),
          quantity: quantity,
          properties: {
            '_bundle_key': bundleKey,
            '_bundle_type': isFree ? 'free' : 'paid',
            '_bundle_index': i,
            '_bundle_quantity': quantity
          }
        };
        
        items.push(item);
      }

      items.push({
        id: Number(mainProductVariantId),
        quantity: 1,
        properties: {
          '_bundle_key': bundleKey,
          '_bundle_ids': bundleIdsStr,
          '_bundle_type': "main",
          '_bundle_set_id': this.activeSetId 
        }
      });
      
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', "X-Requested-With": "XMLHttpRequest" },
          body: JSON.stringify({ items: items })
        });

        if (!response.ok) {
          const err = await response.json().catch(() => null);
          throw err || new Error('Error while adding item(response)');
        }
        
        this.setLoading(false);
        this.cartUpdate();

        if (this.editingBundle) {
          const url = new URL(window.location);
          url.searchParams.delete('edit_bundle');
          url.searchParams.delete('bundle_ids');
          url.searchParams.delete('main_key');
          url.searchParams.delete('bundle_key');
          url.searchParams.delete('set_id'); 
          window.history.replaceState({}, '', url);
          delete this.editingBundle;
        }
      } catch (err) {
        console.error('addToCart error', err);
        this.setLoading(false);
        throw err;
      }
    }

    createFilterButton(filter) {
      return `
        <button class="set-selector__row-item" data-filter="${filter}">
          ${this.renderIcon(filter)}
          <span class="set-selector__item-text text-sm">
            ${filter}
          </span>
        </button>
      `
    }

    renderIcon(filter) {
      switch (filter) {
        case "Almond":
          return `
            <svg width="10" height="20" viewBox="0 0 10 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 1C5.32456 1 5.74436 1.17337 6.24512 1.66602C6.73878 2.15178 7.2192 2.86154 7.64258 3.70117C8.49886 5.39942 9 7.37682 9 8.5293V16.3574C9 17.3369 8.58699 17.9304 7.91211 18.333C7.17135 18.7748 6.07195 19 4.77734 19C3.47946 18.9999 2.52045 18.7736 1.91211 18.3633C1.37303 17.9996 1 17.4198 1 16.3574V8.5293C1 7.37682 1.50114 5.39942 2.35742 3.70117C2.7808 2.86154 3.26122 2.15178 3.75488 1.66602C4.25565 1.17337 4.67546 1 5 1Z" fill="#D1C8F1" stroke="#D1C8F1" stroke-width="2"/>
            </svg>
          `
        case "Round":
          return `
            <svg width="10" height="20" viewBox="0 0 10 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 1C7.03554 1 8.99985 3.08142 9 6.07617V15.7988C9 17.2297 8.54099 17.9356 7.96387 18.3379C7.31326 18.7914 6.31582 19 5 19C3.6842 19 2.68675 18.7914 2.03613 18.3379C1.459 17.9356 1 17.2297 1 15.7988V6.07617C1.00015 3.08143 2.9645 1 5 1Z" fill="#D1C8F1" stroke="#D1C8F1" stroke-width="2"/>
            </svg>
          `
        case "Square":
          return `
            <svg width="10" height="21" viewBox="0 0 10 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.30859 1C6.68716 1 7.54591 1.15419 8.08203 1.56445C8.55024 1.92276 8.99998 2.66932 9 4.51953V16.0273C9 17.8326 8.50654 18.7421 7.91602 19.2354C7.28865 19.7593 6.33515 20 5.04297 20C3.75155 20 2.77013 19.76 2.11816 19.2285C1.50762 18.7307 1 17.8205 1 16.0273V4.51953C1.00003 2.76708 1.54367 2.00862 2.16113 1.61035C2.87905 1.14745 3.9439 1 5.30859 1Z" fill="#D1C8F1" stroke="#D1C8F1" stroke-width="2"/>
            </svg>
          `
        case "Around":
          return `
            <svg width="10" height="20" viewBox="0 0 10 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 1C7.03554 1 8.99985 3.08142 9 6.07617V15.7988C9 17.2297 8.54099 17.9356 7.96387 18.3379C7.31326 18.7914 6.31582 19 5 19C3.6842 19 2.68675 18.7914 2.03613 18.3379C1.459 17.9356 1 17.2297 1 15.7988V6.07617C1.00015 3.08143 2.9645 1 5 1Z" fill="#D1C8F1" stroke="#D1C8F1" stroke-width="2"/>
            </svg>
          `
        case "Coffin":
          return `
            <svg width="10" height="21" viewBox="0 0 10 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.12207 1L8.99902 15.4102C8.99022 17.4841 8.48071 18.5627 7.86914 19.1426C7.24392 19.7353 6.31125 20 5.04297 20C3.77477 20 2.81406 19.7355 2.16504 19.1348C1.5352 18.5517 1.00912 17.4736 1 15.4102L2.87793 1H7.12207Z" fill="#D1C8F1" stroke="#D1C8F1" stroke-width="2"/>
            </svg>
          `;
        case "Stiletto":
          return `
            <svg width="10" height="22" viewBox="0 0 10 28" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.03418 1.61035C5.30578 2.17048 5.58985 2.96293 5.87598 3.94727C6.44666 5.91062 6.9858 8.49782 7.45215 11.1865C8.38849 16.5851 8.99997 22.2128 9 23.7988C9 25.2297 8.54099 25.9356 7.96387 26.3379C7.31326 26.7914 6.31582 27 5 27C3.6842 27 2.68675 26.7914 2.03613 26.3379C1.459 25.9356 1 25.2297 1 23.7988C1.00003 22.2144 1.61132 16.7132 2.54785 11.376C3.01408 8.71904 3.55329 6.14503 4.125 4.15527C4.4116 3.15782 4.69822 2.33579 4.97559 1.7334C4.99521 1.69078 5.01506 1.64992 5.03418 1.61035Z" fill="#D1C8F1" stroke="#D1C8F1" stroke-width="2"/>
            </svg>
          `
        default:
          return ""
      }
    }

    createProductElement(product, collectionType) {
      let imagesHTML = '';
      let dotsHtml = '';
      const firstVariant = product.variants[0];
      const hasVariants = firstVariant.title !== "Default Title";
      const modalId = `modal-size-${collectionType}-${product.id}`;
      const isFree = collectionType === 'free';
      const images = product.images;
      
      images.forEach((image, index) => {
          imagesHTML += `<img src="${image.src}" alt="${image.alt || product.title}" width='${image.width}' height='${image.height}' loading="lazy">`;
          dotsHtml += `<span class="set-selector__slider-dot${index === 0 ? ' active' : ''}"></span>`
      });

      const options = [firstVariant.option1, firstVariant.option2, firstVariant.option3].filter(i => i).join(", ")
      
      return `
        <div class="set-selector__item-wrapper">
          <button type="button"
            class="set-selector__item"
            data-item-button
            data-product-id="${product.id}"
            data-variant-id="${firstVariant.id}"
            data-product-price="${formatMoney(+firstVariant.price*100)}"
            data-product-price-value="${+firstVariant.price*100}"
            data-selected-options="${options || ''}"
            data-product-type="${product.product_type || ''}"
            ${isFree ? 'data-free-product' : ''}
          >
            <span class="set-selector__item-image">
              <img src="${images[0]?.src || ''}" alt="${product.title}" loading="lazy" data-item-image>
              <span class="set-selector__item-price text-sm bold">${formatMoney(firstVariant.price * 100)}</span>
            </span>
            <span class="text-sm" data-product-title>
              ${product.title}
            </span>
          </button>

          ${hasVariants ? `
            <button class="set-selector__item-size-button" type="button" data-size-modal="${modalId}"></button>
            ${this.createSizeModal(product, imagesHTML, dotsHtml, modalId)}
          ` : ''}
        </div>
      `;
    }

    createSizeModal(product, imagesHTML, dotsHtml, modalId) {
      const options = product.options || [];
      const variants = product.variants || [];
    
      function isValueAvailable(optionName, value, selectedValues) {
        return variants.some(variant => {
          if (!variant.available) return false;
          return options.every((opt, idx) => {
            const name = opt.name;
            let expected = selectedValues[name] ?? opt.values[0];
            if (name === optionName) expected = value;
            return variant[`option${idx + 1}`] === expected;
          });
        });
      }
    
      return `
        <div class="set-selector__modal" id="${modalId}" data-modal-options>
          <div class="set-selector__modal-head">
            <button type="button" data-modal-close-size="${modalId}">
              <svg width="7" height="14" viewBox="0 0 7 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 0.789092L1 6.80043L6 12.8118" stroke="#121212" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            <p class="text-lg bold">
              ${window.locales?.quick_view || 'Quick View'}
            </p>
            <span><span></span></span>
          </div>
          <div class="set-selector__modal-body">
            <div class="set-selector__modal-gallery">
              <div class="set-selector__modal-slider">
                ${imagesHTML}
              </div>
              <div class="set-selector__slider-dots">
                ${dotsHtml}
              </div>
            </div>
            <p class="h4 bold">
              ${product.title}
            </p>
            <div class="set-selector__option-picker">
              ${options.map((option) => {
                const selectedValues = {};
                options.forEach(opt => {
                  selectedValues[opt.name] = opt.values[0];
                });
    
                return `
                  <div class="set-selector__option" data-option-container>
                    <div class="set-selector__option-head">
                      <span class="bold text-sm text-subdued">
                        ${option.name}:
                      </span>
                      <span class="text-sm" data-selected-value>
                        ${option.values[0]}
                      </span>
                    </div>
                    <div class="set-selector__option-row">
                      <div class="set-selector__option-values">
                       ${(() => {
                          let firstActiveSet = false;
                          return option.values.map((value) => {
                            const disabled = isValueAvailable(option.name, value, selectedValues) ? '' : 'disabled';
                            const active = !firstActiveSet && !disabled ? (() => { firstActiveSet = true; return ' active'; })() : '';
                            return `
                              <button class="set-selector__option-value button button--outline${active}"
                                type="button"
                                value="${value}"
                                data-value-button
                                ${disabled}>
                                ${value}
                              </button>
                            `;
                          }).join('');
                        })()}
                      </div>
                      ${option.name === "Size" ? `
                        <button class="size-chart-button text-sm text-subdued" 
                          aria-controls="size-chart-Set-selector"
                          aria-expanded="false">
                          ${window.locales?.find_size || 'Find Size'}
                        </button>
                      ` : ''}
                    </div>
                  </div>
                `;
              }).join('')}
            </div>
            <button type="button" class="set-selector__button-confirm button" data-submit-button>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.9277 7.53662L0.11011 7.50171" stroke="currentColor"/>
                <path d="M7.53613 0.110107L7.50123 14.9277" stroke="currentColor"/>
              </svg>
              <span>
                ${window.locales?.choose || 'Choose'}
              </span>
            </button>
          </div>
          <script type="application/json" data-product-variant-ids>${JSON.stringify(variants)}</script>
          <script type="application/json" data-product-options-script>${JSON.stringify(options)}</script>
        </div>
      `;
    }
  }

  new SetSelector();
});